// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.

require("@rails/ujs").start()
require("turbolinks").start()
require("@rails/activestorage").start()
require("channels")

// require("jquery")
// require("jquery-ui")
require("easy-autocomplete")
import "packs/portal-search"

// import "foundation-sites"
// require("src/application")
require("packs/jquery.easy-ticker.js")
require("packs/jquery.timeago.js")
require("packs/jquery.easing.js")


//////Removed in 2021 - Foundation CSS was used for users blue name on hovers - find alternative
//////that doesn't need a 100KB file!
// Foundation.addToJquery($);
// $(document).on('turbolinks:load', function() {
//   $(document).foundation()
// });

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)




////////////////////////
/// To dim current thread in latest_threadbits
/////////////////

// For RH side column
$(document).on('turbolinks:load', function() {
  // Get current thread ID
  const currentThreadId = $('#current-thread-data').data('thread-id');
  
  // Dim the matching thread in latest threads
  $(`.side-latest-threads #thread-${currentThreadId}`).addClass('current-thread-in-latest');
});

// For larger threadbits
$(document).on('turbolinks:load', function() {
  // Get current thread ID
  const currentThreadIdThreadbit = $('#current-thread-data').data('thread-id');
  
  // Dim the matching thread in latest threads
  $(`.threadbit#${currentThreadIdThreadbit}`).addClass('current-thread-in-latest no-display');
});


//Alternative to above in vanilla JS:
//document.addEventListener('turbolinks:load', function() {
//  const id = document.getElementById('current-thread-data')?.dataset.threadId;
//  if (id) document.querySelector(`.side-latest-threads #thread-${id}`)?.classList.add('current-thread-in-latest');
//});



$(document).on('turbolinks:load', function() {
	$("#siteloader").hide();
	// $(".homepage-content, .ftr-wrap").fadeIn("fast");
	$(".homepage-content, .ftr-wrap").show();
	
  document.addEventListener('turbolinks:request-start', function() {
    // $(".homepage-content, .ftr-wrap").fadeOut("fast");
		$(".homepage-content, .ftr-wrap").hide();
		$("#siteloader").fadeIn("fast");
  });

  // document.addEventListener("turbolinks:request-end", function(){
  // 	  // $(".homepage-content, .ftr-wrap").fadeIn("slow");
  // 		$("#siteloader").hide();
  // 		$(".homepage-content, .ftr-wrap").show();
  // });
});




$(document).on('turbolinks:load', function() {
  // When the user scrolls the page, execute myFunction 
  window.onscroll = function() {myFunction()};

  // Get the navbar
  var topbar = document.getElementById("topBar");

  // Get the offset position of the navbar
  var sticky = topbar.offsetTop;

  // Add sticky class to topbar when reaching its scroll position. Remove "sticky" when leaving the scroll position
  function myFunction() {
    if (window.pageYOffset >= sticky) {
      topbar.classList.add("sticky")
    } else {
      topbar.classList.remove("sticky");
    }
  }
});





$(document).on('turbolinks:load', function() {
  jQuery("time.timeago").timeago();
});




// send get forms through turbolinks
$(document).on("submit", "form[data-turboform]", function(e) {
    Turbolinks.visit(this.action+(this.action.indexOf('?') == -1 ? '?' : '&')+$(this).serialize());
    return false;
});





//// reset filters ORIIGNAL FUNCTION
//$(document).on('turbolinks:load', function() {
//	
//  var prev;    
//
//  $('li.fby-selected a').hover(function(){
//  prev = $(this).text();
//      $(this).text("Clear Filter");
//  }, function(){
//      $(this).text(prev)
//  });
//	
//});
//
// reset filters
$(document).on('turbolinks:load', function() {
	
  var prev;    
	$('li.fby-selected a').not('.thread-page li.fby-selected a').hover(function(){
  //$('.homepage li.fby-selected a').hover(function(){ // Swap to this line if need be
  prev = $(this).text();
      $(this).text("Clear Filter");
  }, function(){
      $(this).text(prev)
  });
	
});

// reset sub filter
$(document).on('turbolinks:load', function() {
	
  var prev2;    
	$('li.fby-selected-sub a').not('li.all-categories-page a').hover(function(){
  //$('.homepage li.fby-selected a').hover(function(){ // Swap to this line if need be
  prev2 = $(this).text();
      $(this).text("Clear Category");
  }, function(){
      $(this).text(prev2)
  });
	
});

// Change to 'refresh' for 'All' on home pages
$(document).on('turbolinks:load', function() {
	
  var prev3;    
	$('li.all-categories-page a').hover(function(){
  //$('.homepage li.fby-selected a').hover(function(){ // Swap to this line if need be
  prev3 = $(this).text();
      $(this).text("Reload");
  }, function(){
      $(this).text(prev3)
  });
	
});

// reset filters thread pages
$(document).on('turbolinks:load', function() {
	
  var previous;    

  $('.thread-page li.fby-selected a').hover(function(){
  previous = $(this).text();
      $(this).text("Return Home");
  }, function(){
      $(this).text(previous)
  });
	
});


// For new threadbit flags
// $(document).on('turbolinks:load', function() {
//
// 	var last_visit_id_div = document.getElementsByClassName("last-visit-id");
// 	if (last_visit_id_div) {
// 		var first = last_visit_id_div[0];
// 		var last_visit_id = parseInt(first.id);
// 		var divs = document.getElementsByClassName("pb-label-new");
// 		var item;
// 		for (item = 0; item < divs.length; item++) {
// 	  var actual_id = divs[item].id
// 	  	var id_val = parseInt(actual_id.replace(/\D/g,''));
// 	  	if (id_val < last_visit_id) {
// 	      document.getElementById(actual_id).style.display = 'block';
// 			}
// 		}
// 	}
//
// });

// For 'new' threadbit flags
$(document).on('turbolinks:load', function() {
	
	// alert("loaded?")
	var last_visit_id_div = document.getElementsByClassName("last-visit-id");
	if (last_visit_id_div) {
		var first = last_visit_id_div[0];
		var last_visit_id = parseInt(first.id);
		var divs = document.getElementsByClassName("pb-label-new");
		var item;
		for (item = 0; item < divs.length; item++) {
			var actual_id = divs[item].id;
			// console.log("last_visit_id: " + last_visit_id);
			// console.log("actual_id: " + actual_id);
	  	var id_val = parseInt(actual_id.replace(/\D/g,''));
			// console.log("id_val: " + id_val);
	  	if (parseInt(id_val) > parseInt(last_visit_id)) {
	      document.getElementById(actual_id).style.display = 'block';
			}
		}
	}
	
});




$(document).on('turbolinks:load', function() {
    // Easing
    $.extend(jQuery.easing,{
      easeInOutExpo: function (x, t, b, c, d) {
        if (t==0) return b;
        if (t==d) return b+c;
        if ((t/=d/2) < 1) return c/2 * Math.pow(2, 10 * (t - 1)) + b;
        return c/2 * (-Math.pow(2, -10 * --t) + 2) + b;
      }
    });
    
    var header = $('.top-bar').outerHeight() + 91;
    
    // Add smooth scrolling to all links
    // $('.bit-list-anchors a, .bit-list h2 a').click(function () {
    $('.bit-list-anchors a, .bit-list h2 a, .ftr-base-wrap a, .inpage-btt a').click(function () {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: target.offset().top - header
                }, 350, 'easeInOutExpo');
                return false;
            }
        }
    });
});


$(document).on('turbolinks:load', function() {
	var dd = $('.vticker').easyTicker({
		direction: 'up',
		easing: 'easeInOutBack',
		speed: 'slow',
		interval: 2000,
		height: 'auto',
		visible: 1,
		mousePause: 0,
		controls: {
			up: '.up',
			down: '.down',
			toggle: '.toggle',
			stopText: 'Stop !!!'
		}
	}).data('easyTicker');
});


$(document).on('turbolinks:load', function() {
	// Filter Menu on Mobile
	$("#mobile_filter_toggle").on("click", function(e) {
		e.preventDefault(),
		$(this).closest('#mobile_filter_toggle_wrap').next("#mobile_filter_list").slideToggle();
		var t = "Hide Menu" == $(this).text() ? "Filter By Category" : "Hide Menu";
		$(this).text(t);
	})
});




///////////////////////
// To update Topic Counts
//////////////////////
//function setupTopicCounters() {
//  // Unique container identifier for show page
//  const topicContainer = document.querySelector('[data-topic-counter-container]');
//  if (!topicContainer) return;
//
//  const url = topicContainer.dataset.countsUrl;
//  const topicId = topicContainer.dataset.topicId;
//  if (!url || !topicId) return;
//
//  // Elements with unique show-page classes
//  const viewsCounter = topicContainer.querySelector('.js-show-views');
//  const likesCounter = topicContainer.querySelector('.js-show-likes');
//  const postsCounter = topicContainer.querySelector('.js-show-posts');
//
//  function updateCounters() {
//    // Cache-busting parameter
//    fetch(`${url}?t=${Date.now()}`)
//      .then(response => {
//        if (!response.ok) throw new Error(`HTTP ${response.status}`);
//        return response.json();
//      })
//      .then(data => {
//        console.log("Counter Data Received:", data); // Debug line
//        if (data) {
//          if (viewsCounter) viewsCounter.textContent = data.views;
//          if (likesCounter) likesCounter.textContent = data.likes;
//          if (postsCounter) postsCounter.textContent = data.posts;
//        }
//      })
//      .catch(error => console.error('Counter update failed:', error));
//  }
//
//  // Initial update
//  updateCounters();
//  
//  // Update every 10 minutes
//  const intervalId = setInterval(updateCounters, 600000);
//  
//  // Cleanup
//  document.addEventListener('turbo:before-visit', () => {
//    clearInterval(intervalId);
//  });
//}
//
//// Initialize with conflict protection
//if (!window.topicCountersInitialized) {
//  window.topicCountersInitialized = true;
//  document.addEventListener('turbo:load', setupTopicCounters);
//  document.addEventListener('DOMContentLoaded', setupTopicCounters);
//}




///////////////////////
// To update Topic Counts by Batch
//////////////////////
//function initializeTopicCounters() {
//  const container = document.querySelector('[data-counter-container]');
//  if (!container) return;
//
//  const url = container.dataset.countsUrl;
//  const topics = Array.from(document.querySelectorAll('[data-topic-id]'));
//  
//  // Extract ALL topic IDs at once
//  const allIds = topics.map(topic => topic.dataset.topicId);
//
//  if (allIds.length) {
//    fetch(`${url}?ids=${allIds.join(',')}`)
//      .then(response => {
//        if (!response.ok) throw new Error(`HTTP ${response.status}`);
//        return response.json();
//      })
//      .then(data => {
//        topics.forEach(topic => {
//          const counts = data[topic.dataset.topicId];
//          if (counts) {
//            topic.querySelector('.js-views').textContent = counts.views;
//            topic.querySelector('.js-likes').textContent = counts.likes;
//            topic.querySelector('.js-posts').textContent = counts.posts;
//          }
//        });
//      })
//      .catch(error => console.error('Counter update failed:', error));
//  }
//}
//
//// Initialize on load
//document.addEventListener('DOMContentLoaded', initializeTopicCounters);
//document.addEventListener('turbo:load', initializeTopicCounters);




///////////////////////
// To update Topic Counts (both)
//////////////////////
//$(document).on('turbolinks:load', function() {
//  // SHOW PAGE COUNTERS (fetch once)
//  const showContainer = document.getElementById('main-topic-counters');
//  if (showContainer) {
//    const url = showContainer.dataset.counterUrl;
//    if (!url) return;
//
//    fetch(`${url}?_=${Date.now()}`)
//      .then(response => response.json())
//      .then(data => {
//        $('.js-main-views').text(data.views || '0');
//        $('.js-main-likes').text(data.likes || '0');
//        $('.js-main-posts').text(data.posts || '0');
//      });
//  }
//
//  // INDEX PAGE COUNTERS (fetch once)
//  const indexContainer = $('[data-counter-container]');
//  if (indexContainer.length) {
//    const url = indexContainer.data('counts-url');
//    if (!url) return;
//
//    const topicIds = $('[data-topic-id]').map(function() {
//      return $(this).data('topic-id');
//    }).get();
//
//    if (!topicIds.length) return;
//
//    fetch(`${url}?ids=${topicIds.join(',')}&_=${Date.now()}`)
//      .then(response => response.json())
//      .then(data => {
//        $('[data-topic-id]').each(function() {
//          const topicId = $(this).data('topic-id');
//          const counts = data[topicId] || {};
//          $(this).find('.js-views').text(counts.views || '0');
//          $(this).find('.js-likes').text(counts.likes || '0');
//          $(this).find('.js-posts').text(counts.posts || '0');
//        });
//      });
//  }
//});

// Was working fine, the one below adds more 'resilience'
//$(document).on('turbolinks:load', function() {
//  // 1. SHOW PAGE (Single Topic)
//  const showContainer = document.getElementById('main-topic-counters');
//  if (showContainer) {
//    const url = showContainer.dataset.counterUrl;
//    if (!url) return;
//
//    fetch(`${url}?_=${Date.now()}`)
//      .then(response => response.json())
//      .then(data => {
//        // Update counters
//        $('.js-main-views').text(data.views || '0');
//        $('.js-main-likes').text(data.likes || '0');
//        $('.js-main-posts').text(data.posts || '0');
//      });
//  }
//
//  // 2. INDEX PAGE (Multiple Topics)
//  const indexContainer = $('[data-counter-container]');
//  if (indexContainer.length) {
//    const url = indexContainer.data('counts-url');
//    if (!url) return;
//
//    const topicIds = $('[data-topic-id]').map(function() {
//      return $(this).data('topic-id');
//    }).get();
//
//    if (!topicIds.length) return;
//
//    fetch(`${url}?ids=${topicIds.join(',')}&_=${Date.now()}`)
//      .then(response => response.json())
//      .then(data => {
//        $('[data-topic-id]').each(function() {
//          const topicId = $(this).data('topic-id');
//          const counts = data[topicId] || {};
//          $(this).find('.js-views').text(counts.views || '0');
//          $(this).find('.js-likes').text(counts.likes || '0');
//          $(this).find('.js-posts').text(counts.posts || '0');
//          
//          // Update topic solved status (scoped to this item)
//          const $topicSolved = $(this).find('.js-topic-solved');
//          counts.solved ? $topicSolved.removeClass('no-display') : $topicSolved.addClass('no-display');
//        });
//      });
//  }
//});

$(document).on('turbolinks:load', function() {
  // 1. SHOW PAGE (Single Topic)
  const showContainer = document.getElementById('main-topic-counters');
  if (showContainer && showContainer.dataset.counterUrl) {
    fetch(`${showContainer.dataset.counterUrl}?_=${Date.now()}`)
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(data => {
        $('.js-main-views').text(data.views || '0');
        $('.js-main-likes').text(data.likes || '0');
        $('.js-main-posts').text(data.posts || '0');
      })
      .catch(() => {}); // Silent fail is fine here
  }

  // 2. INDEX PAGE (Multiple Topics)
  const indexContainer = $('[data-counter-container]');
  if (indexContainer.length && indexContainer.data('counts-url')) {
    const topicIds = $('[data-topic-id]').map(function() {
      return $(this).data('topic-id');
    }).get();

    if (topicIds.length) {
      fetch(`${indexContainer.data('counts-url')}?ids=${topicIds.join(',')}&_=${Date.now()}`)
        .then(response => {
          if (!response.ok) throw new Error('Network response was not ok');
          return response.json();
        })
        .then(data => {
          $('[data-topic-id]').each(function() {
            const counts = data[$(this).data('topic-id')] || {};
            const $container = $(this);
            
            $container.find('.js-views').text(counts.views || '0');
            $container.find('.js-likes').text(counts.likes || '0');
            $container.find('.js-posts').text(counts.posts || '0');
            
            // Solved status update
            $container.find('.js-topic-solved')
              .toggleClass('no-display', !counts.solved);
          });
        })
        .catch(() => {}); // Silent fail is fine here
    }
  }
});

// For fliker free attempts (didn't really work)
//$(document).on('turbolinks:load', function() {
//  // 1. SHOW PAGE (Single Topic)
//  const showContainer = document.getElementById('main-topic-counters');
//  if (showContainer && showContainer.dataset.counterUrl) {
//    fetch(`${showContainer.dataset.counterUrl}?_=${Date.now()}`)
//      .then(response => response.json())
//      .then(data => {
//        $('.js-main-views .counter-value').text(data.views || '0');
//        $('.js-main-likes .counter-value').text(data.likes || '0');
//        $('.js-main-posts .counter-value').text(data.psts || '0');
//      })
//      .catch(() => {}); // Silent fail
//  }
//
//  // 2. INDEX PAGE (Multiple Topics)
//  const indexContainer = $('[data-counter-container]');
//  if (indexContainer.length && indexContainer.data('counts-url')) {
//    const topicIds = $('[data-topic-id]').map(function() {
//      return $(this).data('topic-id');
//    }).get();
//
//    if (topicIds.length) {
//      fetch(`${indexContainer.data('counts-url')}?ids=${topicIds.join(',')}&_=${Date.now()}`)
//        .then(response => response.json())
//        .then(data => {
//          $('[data-topic-id]').each(function() {
//            const counts = data[$(this).data('topic-id')] || {};
//            const $container = $(this);
//            
//            $container.find('.js-views .counter-value').text(counts.views || '0');
//            $container.find('.js-likes .counter-value').text(counts.likes || '0');
//            $container.find('.js-posts .counter-value').text(counts.posts || '0');
//            $container.find('.js-topic-solved').toggleClass('no-display', !counts.solved);
//          });
//        })
//        .catch(() => {}); // Silent fail
//    }
//  }
//});






///////////////////////
// Portal faves system
//////////////////////
// Lists all saved portals
$(document).on('turbolinks:load', function() {
  
  if (document.getElementById('users-saved-portals')) {
    var saved_portals = document.getElementById('users-saved-portals').innerHTML.trim().split(',');
    for (const portal of saved_portals) {
      var ul = document.getElementById('saved-portals');
      var li = document.createElement("li");
      var aTag = document.createElement('a');
      aTag.setAttribute('href', ("/" + portal.trim()));
      aTag.innerText = ("/" + portal.trim());
      li.appendChild(aTag);
      ul.appendChild(li);
    }
    var cln = ul.cloneNode(true);
    document.getElementById('saved-portals-mobile').replaceWith(cln);
  }
  
	
  // shows the heart status
  if (document.getElementsByClassName("portal-slug")[0]) {
  	var portal_slug = document.getElementsByClassName("portal-slug")[0].innerHTML;
  	if (portal_slug && saved_portals && saved_portals.includes(portal_slug)) {
      var heart_div = document.getElementsByClassName("portal-heart-saved")[0];
      var aTag = document.createElement('a');
      aTag.setAttribute('href',("/" + portal_slug + "/unsave"));
      aTag.innerHTML = "<span title='Remove fave'></span>";
      heart_div.appendChild(aTag);
      heart_div.style.display = 'block';
  	} else {
      var heart_div = document.getElementsByClassName("portal-heart")[0];
      var aTag = document.createElement('a');
      aTag.setAttribute('href',("/" + portal_slug + "/save"));
      aTag.innerHTML = "<span title='Add fave'></span>";
      heart_div.appendChild(aTag);
      heart_div.style.display = 'block';
    }
  }
  
  // if (document.getElementsByClassName("portal-slug")[0]) {
  //   var portal_slug = document.getElementsByClassName("portal-slug")[0].innerHTML;
  //   // returns a string, eg "groovy"
  //   if (portal_slug) {
  //     var heart_div = document.getElementsByClassName("portal-heart")[0];
  //     var aTag = document.createElement('a');
  //     aTag.setAttribute('href',("/" + portal_slug + "/save"));
  //     aTag.innerHTML = "<span title='Add fave'></span>";
  //     heart_div.appendChild(aTag);
  //   }
  // }

});